"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/event/v1/cms_common.proto (package spwn.event.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMSEventTicketSales = exports.CMSPart = exports.CMSEvent = exports.EventTicket = exports.CMSEventStatus = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from enum spwn.event.v1.CMSEventStatus
 */
var CMSEventStatus;
(function (CMSEventStatus) {
    /**
     * @generated from enum value: CMS_EVENT_STATUS_UNSPECIFIED = 0;
     */
    CMSEventStatus[CMSEventStatus["CMS_EVENT_STATUS_UNSPECIFIED"] = 0] = "CMS_EVENT_STATUS_UNSPECIFIED";
    /**
     * @generated from enum value: CMS_EVENT_STATUS_DRAFT = 1;
     */
    CMSEventStatus[CMSEventStatus["CMS_EVENT_STATUS_DRAFT"] = 1] = "CMS_EVENT_STATUS_DRAFT";
    /**
     * @generated from enum value: CMS_EVENT_STATUS_ACTIVE = 2;
     */
    CMSEventStatus[CMSEventStatus["CMS_EVENT_STATUS_ACTIVE"] = 2] = "CMS_EVENT_STATUS_ACTIVE";
})(CMSEventStatus = exports.CMSEventStatus || (exports.CMSEventStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(CMSEventStatus)
protobuf_1.proto3.util.setEnumType(CMSEventStatus, "spwn.event.v1.CMSEventStatus", [
    { no: 0, name: "CMS_EVENT_STATUS_UNSPECIFIED" },
    { no: 1, name: "CMS_EVENT_STATUS_DRAFT" },
    { no: 2, name: "CMS_EVENT_STATUS_ACTIVE" },
]);
/**
 * @generated from message spwn.event.v1.EventTicket
 */
class EventTicket extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * チケットID
         *
         * @generated from field: string ticket_id = 1;
         */
        this.ticketId = "";
        /**
         * イベントID
         *
         * @generated from field: string event_id = 2;
         */
        this.eventId = "";
        /**
         * イベントタイトル
         *
         * @generated from field: string event_title = 3;
         */
        this.eventTitle = "";
        /**
         * 日時設定.販売終了日時
         *
         * @generated from field: int64 close_date_time = 4;
         */
        this.closeDateTime = protobuf_1.protoInt64.zero;
        /**
         * チケット情報.チケット説明文
         *
         * @generated from field: string description = 5;
         */
        this.description = "";
        /**
         * チケット情報.購入制限数
         *
         * @generated from field: int64 purchase_limit = 6;
         */
        this.purchaseLimit = protobuf_1.protoInt64.zero;
        /**
         * チケット情報.価格
         *
         * @generated from field: double price_jpy = 7;
         */
        this.priceJpy = 0;
        /**
         * 日時設定.視聴期限
         *
         * @generated from field: int64 expired_date_time = 8;
         */
        this.expiredDateTime = protobuf_1.protoInt64.zero;
        /**
         * 公開設定
         *
         * @generated from field: bool display = 9;
         */
        this.display = false;
        /**
         * チケット情報.在庫数
         *
         * @generated from field: int64 total = 10;
         */
        this.total = protobuf_1.protoInt64.zero;
        /**
         * チケット情報.チケット名
         *
         * @generated from field: string name = 11;
         */
        this.name = "";
        /**
         * 日時設定.販売開始日時
         *
         * @generated from field: int64 release_date_time = 12;
         */
        this.releaseDateTime = protobuf_1.protoInt64.zero;
        /**
         * 日時設定.チケット購入完了後の視聴有効期間（日） ticketType === 'vod'の場合のみ
         *
         * @generated from field: int64 vod_active_hours = 13;
         */
        this.vodActiveHours = protobuf_1.protoInt64.zero;
        /**
         * 視聴設定 ticketType === 'Venue'の場合のみ? (視聴できる対象 Video ID を入れる)
         *
         * @generated from field: repeated string video_ids = 14;
         */
        this.videoIds = [];
        /**
         * チケット情報.サービス手数料
         *
         * @generated from field: int64 service_fee = 15;
         */
        this.serviceFee = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EventTicket().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EventTicket().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EventTicket().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(EventTicket, a, b);
    }
}
exports.EventTicket = EventTicket;
EventTicket.runtime = protobuf_1.proto3;
EventTicket.typeName = "spwn.event.v1.EventTicket";
EventTicket.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "close_date_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "purchase_limit", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "price_jpy", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "expired_date_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "display", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "total", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 11, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "release_date_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 13, name: "vod_active_hours", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 14, name: "video_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 15, name: "service_fee", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message spwn.event.v1.CMSEvent
 */
class CMSEvent extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * イベントタイトル
         *
         * @generated from field: string event_title = 2;
         */
        this.eventTitle = "";
        /**
         * イベントバナー
         *
         * @generated from field: string event_banner = 3;
         */
        this.eventBanner = "";
        /**
         * イベントバナーのパス
         *
         * @generated from field: string event_banner_path = 4;
         */
        this.eventBannerPath = "";
        /**
         * イベント詳細
         *
         * @generated from field: string description = 5;
         */
        this.description = "";
        /**
         * 開場日時
         *
         * @generated from field: int64 part_open_time = 7;
         */
        this.partOpenTime = protobuf_1.protoInt64.zero;
        /**
         * 配信開始日時
         *
         * @generated from field: int64 part_start_time = 8;
         */
        this.partStartTime = protobuf_1.protoInt64.zero;
        /**
         * 配信終了日時
         *
         * @generated from field: int64 event_end_time = 9;
         */
        this.eventEndTime = protobuf_1.protoInt64.zero;
        /**
         * 登録状況
         *
         * @generated from field: spwn.event.v1.CMSEventStatus status = 10;
         */
        this.status = CMSEventStatus.CMS_EVENT_STATUS_UNSPECIFIED;
        /**
         * ドメイン
         *
         * @generated from field: repeated string domains = 11;
         */
        this.domains = [];
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEvent, a, b);
    }
}
exports.CMSEvent = CMSEvent;
CMSEvent.runtime = protobuf_1.proto3;
CMSEvent.typeName = "spwn.event.v1.CMSEvent";
CMSEvent.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "event_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "event_banner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "event_banner_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "open", kind: "scalar", T: 3 /* ScalarType.INT64 */, opt: true },
    { no: 7, name: "part_open_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "part_start_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "event_end_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 10, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(CMSEventStatus) },
    { no: 11, name: "domains", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * @generated from message spwn.event.v1.CMSPart
 */
class CMSPart extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * パート名（"昼の部"等, CMSでは単パートのため公演名）
         *
         * @generated from field: string name = 1;
         */
        this.name = "";
        /**
         * 会場時間
         *
         * @generated from field: int64 open_time = 2;
         */
        this.openTime = protobuf_1.protoInt64.zero;
        /**
         * 開始時間
         *
         * @generated from field: int64 start_time = 3;
         */
        this.startTime = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSPart().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSPart().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSPart().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSPart, a, b);
    }
}
exports.CMSPart = CMSPart;
CMSPart.runtime = protobuf_1.proto3;
CMSPart.typeName = "spwn.event.v1.CMSPart";
CMSPart.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "open_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "start_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * イベントのチケット売上枚数
 *
 * @generated from message spwn.event.v1.CMSEventTicketSales
 */
class CMSEventTicketSales extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * イベントID
         *
         * @generated from field: string event_id = 1;
         */
        this.eventId = "";
        /**
         * チケットID
         *
         * @generated from field: string ticket_id = 2;
         */
        this.ticketId = "";
        /**
         * チケット名
         *
         * @generated from field: string ticket_name = 3;
         */
        this.ticketName = "";
        /**
         * 売上枚数
         *
         * @generated from field: int32 amount = 4;
         */
        this.amount = 0;
        /**
         * チケットの公開日時
         *
         * @generated from field: int64 release_date_time = 5;
         */
        this.releaseDateTime = protobuf_1.protoInt64.zero;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CMSEventTicketSales().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CMSEventTicketSales().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CMSEventTicketSales().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(CMSEventTicketSales, a, b);
    }
}
exports.CMSEventTicketSales = CMSEventTicketSales;
CMSEventTicketSales.runtime = protobuf_1.proto3;
CMSEventTicketSales.typeName = "spwn.event.v1.CMSEventTicketSales";
CMSEventTicketSales.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "event_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "ticket_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "ticket_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "release_date_time", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
//# sourceMappingURL=cms_common_pb.js.map